export default "__VITE_ASSET__1GEChUmN__"